import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgX = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <mask
      id="X_svg__a"
      width={10}
      height={10}
      x={19}
      y={7}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M28.15 7.29h-8.34v9.6h8.34z"
      />
    </mask>
    <g mask="url(#X_svg__a)">
      <path
        stroke="#00215B"
        strokeMiterlimit={10}
        d="m18.49 17.33 9.13-10.38"
      />
    </g>
    <path
      fill="#00C5F2"
      d="M13.93 5H5l21.07 30H35z"
    />
    <mask
      id="X_svg__b"
      width={31}
      height={28}
      x={5}
      y={7}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M35.61 7.29H5V35h30.61z"
      />
    </mask>
    <g mask="url(#X_svg__b)">
      <path
        stroke="#00215B"
        strokeMiterlimit={10}
        d="M31.39 33.14h-4.07L8.61 6.95"
      />
    </g>
    <path
      fill="#00C5F2"
      d="M22.85 17.7 34.02 5h-2.64l-9.7 11.03zM16.71 21.68 5 35h2.65l10.24-11.65z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgX);

export default ForwardRef;
